import request from '../../src/state/modules/axios'

export function getExperience(){
    return request({
        url: '/api/work-experiences',
        method: 'get',
    })
}

export function getExperienceById(data){
    return request({
        url: `/api/work-experiences/${data.id}`,
        method: 'get',
    })
}

export function addExperience(data){
    return request({
        url: '/api/work-experiences',
        method: 'post',
        data,
    })
}

export function editExperience(data){
    return request({
        url: `/api/work-experiences/${data.id}`,
        method: 'put',
        data,
    })
}

export function deleteExperience(data){
    return request({
        url: `/api/work-experiences/${data.id}`,
        method: 'delete'
    })
}